import React, { Component } from "react";
import { Button, InputFactory, dialog } from "nq-component";
import BasePage from "../../../base/BasePage";
import FormFactory from "../../FormFactory";

export default class View extends BasePage {
  capitalized(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  renderField(key, value) {
    if (Array.isArray(value)) {
      return (
        <div key={key} className="mb-4">
          <label>{this.capitalized(key)}</label>
          {value.map((item, index) => (
            <InputFactory
              key={index}
              type="String"
              disabled={true}
              value={item}
            />
          ))}
        </div>
      );
    } else if (typeof value === "object" && value !== null) {
      if (key === "employee") {
        return (
          <div key={key} className="mb-4">
            <label>{this.capitalized(key)}</label>
            <InputFactory
              type="String"
              disabled={true}
              value={`${value.Firstname} ${value.Middlename} ${value.surname}`}
            />
          </div>
        );
      } else if (key === "requestType") {
        return (
          <div key={key} className="mb-4">
            <label>{this.capitalized(key)}</label>
            <InputFactory
              type="String"
              disabled={true}
              value={`${value.name}`}
            />
          </div>
        );
      } else {
        return (
          <div key={key} className="mb-4">
            <label>{this.capitalized(key)}</label>
            {Object.keys(value).map((subKey) => (
              <InputFactory
                key={subKey}
                type="String"
                disabled={true}
                value={value[subKey]}
              />
            ))}
          </div>
        );
      }
    } else if (this.isValidDate(value)) {
      return (
        <div key={key} className="mb-4">
          <label>{this.capitalized(key)}</label>
          <InputFactory
            type="String"
            disabled={true}
            value={this.formatDate(value)}
          />
        </div>
      );
    } else {
      return (
        <div key={key} className="mb-4">
          <label>{this.capitalized(key)}</label>
          <InputFactory type="String" disabled={true} value={value} />
        </div>
      );
    }
  }

  render() {
    const { object, collection } = this.props;
    const excludeFields = [
      "id",
      "createdAt",
      "updatedAt",
      "status",
      "isEnable",
    ];

    console.log("Col: ", collection);

    // const fields = Object.keys(object)
    //   .filter((key) => !excludeFields.includes(key))
    //   .map((key) => this.renderField(key, object[key]));

    // console.log("FIELDS: ", fields);
    return (
      <div className="row p-3">
        <div className="d-flex" style={{ borderBottom: "1.5px solid #d3d3d3" }}>
          <p className="fs-6 fw-bold">
            {collection?.label ? collection?.label : collection?.collection}{" "}
            Details
          </p>
        </div>

        {/* {fields} */}
        <div className="p-3">
          <FormFactory
            className="p-1"
            schema={collection}
            disabled={true}
            object={object}
            // onChange={this.onChange.bind(this)}
            excludeFields={Object.keys(collection.fields).reduce((acc, key) => {
              const options = collection.fields[key];
              if (options.read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "Pointer":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            }, excludeFields)}
          />
        </div>

        <div style={{ borderTop: "1.5px solid #d3d3d3" }}>
          <Button
            onClick={() => dialog.close()}
            className="btn btn-danger mt-4 ms-auto"
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
}
